import {
  Box,
  IconButton,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import React, { useContext } from "react";
import { LANGUAGES } from "../../../../config/languages";
import { ConfigContext } from "../../../../contexts/ConfigContext";
import { useLanguages } from "../../../../utils/hooks/useLanguages";
import { LANGUAGE_PARAMS } from "./constants/LanguageParams";

export const LanguageSelector = () => {
  const {
    state: { language: currentLanguage },
  } = useContext(ConfigContext);

  const { breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));

  const { setLanguageInApp } = useLanguages();

  const useStyles = makeStyles({
    root: {
      "& .MuiMenuItem-root": {
        minHeight: 0,
      },
    },
  });

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (language) => {
    if (language) {
      setLanguageInApp(language);
    }
    setAnchorEl(null);
  };

  const classes = useStyles();

  if (!currentLanguage) return null;

  return (
    <>
      <IconButton
        onClick={handleMenuClick}
        aria-label={getLangParams(currentLanguage)?.label}
        style={{
          position: "fixed",
          top: isScreenXs ? "14px" : "8px",
          right: "0.8rem",
          zIndex: 9999,
        }}
      >
        <img
          alt={getLangParams(currentLanguage)?.label}
          src={getLanguageImageByLanguage(currentLanguage)}
          style={{ height: 18, width: 18 }}
        />
      </IconButton>
      <Menu
        className={classes.root}
        id="simple-menu"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
      >
        {Object.values(LANGUAGES).map((language, i) => (
          <MenuItem key={i} onClick={() => handleClose(language)}>
            <Box display={"flex"} alignItems={"center"}>
              <img
                alt={language}
                src={getLanguageImageByLanguage(language)}
                style={{ height: 18, width: 18 }}
              />
              <Typography
                variant="subtitle2"
                color={"textSecondary"}
                style={{
                  paddingLeft: "8px",
                  fontWeight: language === currentLanguage ? "700" : "400",
                }}
              >
                {getLangParams(language)?.label}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const getLangParams = (language) => {
  if (!Object.keys(LANGUAGE_PARAMS).includes(language)) {
    return { alpha_3: "unknown", label: "unknown" };
  }
  return LANGUAGE_PARAMS[language];
};

const getLanguageImageByLanguage = (language) => {
  return `https://cdn.nemuru.com/assets/icons/countries/alpha_3/${
    getLangParams(language)?.alpha_3
  }.svg`;
};
